namespace TabAurous.Production {
    export interface ReceiptMaterialItemsForm {
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
    }

    export class ReceiptMaterialItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.ReceiptMaterialItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptMaterialItemsForm.init)  {
                ReceiptMaterialItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(ReceiptMaterialItemsForm, [
                    'DepartmentId', w0,
                    'BagNo', w1,
                    'ProductCode', w1,
                    'Line_No', w1,
                    'Pieces', w2
                ]);
            }
        }
    }
}
